import React, { useState, createContext } from 'react';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  let data = JSON.parse(localStorage.getItem('data'));
  const nowDate = new Date().getTime();
  let expires = new Date(data?.expiryDate).getTime();
  const [auth, setAuth] = useState(data && nowDate < expires ? data : {});
  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
